/* Essentzia – barra "Aggiungi al carrello" fissa in basso su mobile (schede caffè).
   Compare quando il bottone originale non è visibile e lo richiama:
   stessa variante, stessa quantità, stesso testo del bottone. */
(function () {
  function init() {
    var atc = document.querySelector('.product__info-container .product-form__submit');
    var h1 = document.querySelector('.product__title h1');
    if (!atc || document.getElementById('ess-sticky-atc')) return;

    var bar = document.createElement('div');
    bar.id = 'ess-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ess-sticky__info"><div class="ess-sticky__title"></div><div class="ess-sticky__meta"></div></div>' +
      '<button type="button" tabindex="-1"></button>';
    document.body.appendChild(bar);

    var title = bar.querySelector('.ess-sticky__title');
    var meta = bar.querySelector('.ess-sticky__meta');
    var btn = bar.querySelector('button');
    title.textContent = h1 ? h1.textContent.trim() : '';

    function sync() {
      var price = Array.prototype.find.call(
        document.querySelectorAll('.product__info-container [id^="price-"] .price-item'),
        function (el) { return el.offsetParent !== null && el.textContent.trim(); }
      );
      var opts = Array.prototype.map.call(
        document.querySelectorAll('variant-selects input[type=radio]:checked, variant-selects select'),
        function (el) { return el.value; }
      );
      meta.textContent = [price ? price.textContent.trim() : ''].concat(opts).filter(Boolean).join(' · ');
      btn.textContent = atc.textContent.trim();
      btn.disabled = atc.disabled;
    }

    sync();
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 400);
    });
    new MutationObserver(sync).observe(atc, { attributes: true, childList: true, subtree: true });
    var priceBox = document.querySelector('.product__info-container [id^="price-"]');
    if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
    window.addEventListener('load', function () { setTimeout(sync, 300); });
    btn.addEventListener('click', function () { atc.click(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(atc);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
